import type { ReactNode } from 'react';
import { useForceLight } from '../lib/theme';

export default function ForceLight({ children }: { children: ReactNode }) {
  useForceLight();
  return <>{children}</>;
}
